import { Box, Button, Dialog } from '@hubii/ds-hubii'

import Typography from '@components/Typography/Typography'

type IConnectionDialog = {
  open: boolean
  onDismiss: () => void
}

const ErrorConnectionDialog = (props: IConnectionDialog) => {
  const { open, onDismiss } = props

  const handleRefresh = () => {
    window.location.reload()
  }

  return (
    <Dialog isOpen={open} dataTestId='' onClose={onDismiss}>
      <Box dataTestId='' className='overflow-auto relative w-full h-full '>
        <div className='z-10 relative p-2 text-center gap-3'>
          <Typography variant='h6' color='error'>
            Atenção! Você está desconectado!
          </Typography>
          <Typography variant='body1' className='pt-4 max-w-lg m-auto' color='textPrimary'>
            Por favor, verifique sua conexão com a internet e tente novamente. Obrigado pela sua
            compreensão.
          </Typography>
        </div>

        <div className='z-10 relative mt-3 px-4 flex justify-center'>
          <Button color='primary' onClick={handleRefresh} dataTestId='button-refresh-page'>
            Atualizar a página
          </Button>
        </div>
      </Box>
    </Dialog>
  )
}

export default ErrorConnectionDialog
